export default __webpack_public_path__ + "static/media/Asset 5.d7af16b5.svg";